import { iconA11y, type IconProps } from './iconProps';

export function SpeakerIcon({ size = 24, title, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...iconA11y(title)}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M3 9v6h4l5 4.5v-15L7 9H3z"
        fill="currentColor"
      />
      <path
        d="M15.5 8.5a4.5 4.5 0 0 1 0 7"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        data-wave="inner"
      />
      <path
        d="M18 6a8 8 0 0 1 0 12"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        data-wave="outer"
      />
    </svg>
  );
}
